module.exports = __webpack_public_path__ + "static/media/upload.ae92721e.svg";